gsap.registerPlugin(Observer);

let lastScrollTop = 0;

window.addEventListener("DOMContentLoaded", function () {
  //Prevent page reload to memory scroll position. Usefull when using multiple scrolltrigger
  // ScrollTrigger.clearScrollMemory("manual");
  window.history.scrollRestoration = "manual";
  //Detect scroll status
  window.addEventListener("scroll", scrolling);

  const sections = document.querySelectorAll(".section-quote");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          observer.unobserve(entry.target); // Arrête d'observer une fois visible
        }
      });
    },
    { threshold: 0.5 },
  ); // 10% visible pour déclencher

  sections.forEach((section) => observer.observe(section));
});
function hoverMenu(el) {
  if(window.innerWidth<1024) return
  document.documentElement.classList.add("menu-open");
  const entries = el.querySelectorAll(".submenu li");
  gsap.killTweensOf(entries);
  gsap.to(entries, {
    opacity: 1,
    y: 0,
    duration: 0.3,
    stagger: 0.05,
    ease: "power2.out",
  });
}

function leaveHoverMenu(el) {
  if(window.innerWidth<1024) return
  document.documentElement.classList.remove("menu-open");
  const entries = el.querySelectorAll(".submenu li");

  if (window.innerWidth > 1024) {
    gsap.killTweensOf(entries);
    gsap.to(entries, {
      opacity: 0,
      y: "-10px",
      duration: 0.3,
      stagger: -0.05,
      ease: "power2.out",
    });
  }
}

function mobileMenu() {
  document.documentElement.classList.toggle("menuMobile-open");
}

function toggleSubmenu(el) {
  el.parentNode.classList.toggle("active");
}

function openContact() {
  if (document.documentElement.classList.contains("cart-drawer")) openCart();
  document.documentElement.classList.toggle("menu-open");
  document.querySelector(".header_contact").classList.toggle("active");
  const entries = document.querySelectorAll(".contact_container > div > *");
  gsap.killTweensOf(entries);
  if (document.documentElement.classList.contains("menu-open")) {
    gsap.to(entries, {
      opacity: 1,
      x: 0,
      duration: 0.4,
      stagger: 0.05,
      ease: "power4.out",
    });
  } else {
    gsap.to(entries, {
      opacity: 0,
      x: "120%",
      duration: 0.4,
      stagger: -0.05,
      ease: "power4.out",
    });
  }
}

function openCart() {
  if (document.documentElement.classList.contains("menu-open")) openContact();
  document.documentElement.classList.toggle("cart-drawer");
}

function scrolling() {
  let scrollTop = window.scrollY || document.documentElement.scrollTop;
  window.scrollY > 100 && scrollTop > lastScrollTop
    ? document.documentElement.classList.add("scroll-down")
    : document.documentElement.classList.remove("scroll-down");
  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;

  if (window.scrollY > 10) document.documentElement.classList.add("not-top");
  else document.documentElement.classList.remove("not-top");
}

//Some utility function
function globalScrollTriggerRefresh() {
  const tmp = window.scrollY;
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "instant",
  });
  ScrollTrigger.refresh();
  window.scrollTo({
    top: tmp,
    left: 0,
    behavior: "instant",
  });
}
function goTo(div, offset) {
  window.scrollTo({
    top: document.querySelector(div).offsetTop - offset,
    left: 0,
    behavior: "smooth",
  });
}
function is_touch_device() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

function addToCart(e) {
  e.preventDefault();
  e.target.querySelector('[type="submit"]').disabled = true;

  let formData = Object.fromEntries(new FormData(e.target));

  // Gestion dynamique des propriétés (properties[])
  let properties = {};
  for (const key in formData) {
    if (key.startsWith("properties[")) {
      let propName = key.match(/properties\[(.*?)\]/)[1];
      properties[propName] = formData[key];
      delete formData[key]; // On enlève la propriété brute du formData
    }
  }
  if (Object.keys(properties).length > 0) formData.properties = properties; // Ajout des propriétés dynamiques dans formData

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      const erreurs = data.errors || data.description;
      if (erreurs) {
        addToCartErrors(erreurs);
        e.target.querySelector('[type="submit"]').disabled = false;
        return false;
      } else {
        hideAddToCartErrors();
      }
      // console.log(JSON.stringify(Object.fromEntries(new FormData(e.target))))
      updateCart(data);
      document.documentElement.classList.add("cart-drawer");
      e.target.querySelector('[type="submit"]').disabled = false;
    })
    .catch((error) => {
      console.error("Erreur :", error);
    });
}

function addToCartErrors(message) {
  // document.querySelector(".product_errors").classList.remove("hidden");
  // document.querySelector(".product_errors_message").textContent = message;
  return false;
}
function hideAddToCartErrors() {
  // document.querySelector(".product_errors").classList.add("hidden");
}

function minQuantity(e) {
  var currentValue = e.parentNode.querySelector("input").value;
  if (currentValue == 1) return;

  currentValue--;
  e.parentNode.querySelector("input").value = currentValue;
  e.parentNode.querySelector("span").innerText = currentValue;
}

window.updateCart = () => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  fetch(homeUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Pas de réponse réseau " + response.statusText);
      }
      return response.text();
    })
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const cartDrawer = doc.querySelector("#cart-drawer");
      if (cartDrawer) {
        document.querySelector("#cart-drawer").innerHTML = cartDrawer.innerHTML;
      } else {
        console.error("#cart-drawer non trouvé sur la page");
      }
      document.querySelector("#cart-drawer")?.classList.remove("loading");
      const swiper = new Swiper(".cart-product_swiper", {
        navigation: {
          prevEl: ".cart-swiper_nav div:first-of-type",
          nextEl: ".cart-swiper_nav div:last-of-type",
        },
        breakpoints: {
          0: {
            slidesPerView: 1.2,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 1.5,
            spaceBetween: 16,
          },
        },
      });
    })
    .catch((error) => {
      console.error("Erreur fetch :", error);
      document.querySelector("#cart-drawer")?.classList.remove("loading");
    });

  updateCartLink();
};

window.updateQuantity = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  const quantity = parseInt(
    el.parentNode.querySelector("[name='quantity']").value,
  );

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
    .then((response) => {
      if (response.ok) {
        window.updateCart();
        if (quantity === 0) el.closest(".cartDrawer_item").remove();
      } else {
        console.error("Impossible de mettre à jour le cart");
      }
    })
    .catch((error) => console.error("Erreur :", error));

  return false;
};

window.reduceQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  const quantity =
    parseInt(el.parentNode.querySelector("[name='quantity']").value) - 1;

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
    .then((response) => {
      if (response.ok) {
        window.updateCart();
        if (quantity === 0) el.closest(".cartDrawer_item").remove();
      } else {
        console.error("Impossible de mettre à jour le cart");
      }
    })
    .catch((error) => console.error("Erreur :", error));

  return false;
};

window.increaseQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  const quantity =
    parseInt(el.parentNode.querySelector("[name='quantity']").value) + 1;

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
    .then((response) => response.json())
    .then((data) => {
      const erreurs = data.errors || data.description;
      if (erreurs) {
        el.parentNode.parentNode.parentNode
          .querySelector(".product_errors")
          .classList.remove("hidden");
        el.parentNode.parentNode.parentNode.querySelector(
          ".product_errors_message",
        ).textContent = erreurs;
        document.querySelector("#cart-drawer")?.classList.remove("loading");
        return false;
      } else {
        // el.parentNode.parentNode.parentNode
        //   .querySelector(".product_errors")
        //   .classList.add("hidden");
        window.updateCart();
      }
    })
    .catch((error) => console.error("Erreur :", error));

  return false;
};

window.changeQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  // const quantity = parseInt(el.parentNode.querySelector('span').textContent) + 1
  const quantity = el.value;
  console.log(itemId);

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
    .then((response) => response.json())
    .then((data) => {
      const erreurs = data.errors || data.description;
      if (erreurs) {
        // el.parentNode.parentNode.parentNode
        //   .querySelector(".product_errors")
        //   .classList.remove("hidden");
        // el.parentNode.parentNode.parentNode.querySelector(
        //   ".product_errors_message"
        // ).textContent = erreurs;
        console.log(erreurs);
        document.querySelector("#cart-drawer")?.classList.remove("loading");
        return false;
      } else {
        // el.parentNode.parentNode.parentNode
        //   .querySelector(".product_errors")
        //   .classList.add("hidden");
        window.updateCart();
      }
    })
    .catch((error) => console.error("Erreur :", error));

  return false;
};

window.removeQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=0`,
  })
    .then((response) => {
      if (response.ok) {
        window.updateCart();
        el.closest(".cartDrawer_item").remove();
      } else {
        console.error("Impossible de vider le cart");
      }
    })
    .catch((error) => console.error("Erreur :", error));

  return false;
};

window.emptyCart = () => {
  fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Panier vidé avec succès", data);
    })
    .catch((error) => {
      console.error("Erreur emptyCart :", error);
    });
};

function plusQuantity(e, maxStock) {
  e.parentNode
    .querySelector('[onclick^="minQuantity"]')
    .classList.remove("off");
  var currentValue = e.parentNode.querySelector("input").value;
  if (currentValue == maxStock) return;
  currentValue++;
  e.parentNode.querySelector("input").value = currentValue;
  if (currentValue == maxStock)
    e.parentNode
      .querySelector('[onclick^="plusQuantity"]')
      .classList.add("off");
}

function minQuantity(e) {
  e.parentNode
    .querySelector('[onclick^="plusQuantity"]')
    .classList.remove("off");
  var currentValue = e.parentNode.querySelector("input").value;
  if (currentValue == 1) return;

  currentValue--;
  if (currentValue == 1)
    e.parentNode.querySelector('[onclick^="minQuantity"]').classList.add("off");
  e.parentNode.querySelector("input").value = currentValue;
}

function updateCartLink() {
  fetch("/cart/update")
    .then((response) => response.text())
    .then((data) => {
      let parser = new DOMParser();
      let doc = parser.parseFromString(data, "text/html");
      let newCartContent = doc.querySelector(".open-cart-link").innerHTML;
      document.querySelector(".open-cart-link").innerHTML = newCartContent;
      console.log(newCartContent);
    })

    .catch((error) =>
      console.error("Erreur lors de la mise à jour du panier :", error),
    );
}

function filterCat(el, category) {
  const categoryName = category;
  const pushCollection = document.querySelector(".collection_push");
  document.querySelectorAll(".card-product").forEach((el) => {
    if (categoryName == "all") el.classList.remove("hidden");
    else if (el.dataset.categorie == categoryName)
      el.classList.remove("hidden");
    else el.classList.add("hidden");
  });

  document
    .querySelector(".collection_filter.active")
    .classList.remove("active");

  el.classList.add("active");
  console.log(categoryName);
  if (categoryName == "all") {
    pushCollection.classList.remove("hidden");
  } else {
    pushCollection.classList.add("hidden");
  }
}

function productFAQ(e) {
  if (e.parentNode.classList.contains("active"))
    e.parentNode.classList.remove("active");
  else {
    if (document.querySelector(".faq_item.active")) {
      document.querySelector(".faq_item.active").classList.remove("active");
    }
    e.parentNode.classList.add("active");
  }
}

function playVideo(e) {
  const video = e.querySelector("video");
  const button = e.querySelector("button");

  if (!e.classList.contains("is-playing")) {
    // Ensure video is in a playable state before calling play()
    if (video.readyState >= 2) {
      try {
        video.muted = false;
        video
          .play()
          .then(() => {
            // Only update UI after successful play
            button.classList.add("hidden");
            e.classList.add("is-playing");
          })
          .catch((error) => {
            console.error("Error playing video:", error);
            video.muted = true; // Fallback for autoplay restrictions
          });
      } catch (error) {
        console.error("Unexpected play error:", error);
      }
    } else {
      console.warn("Video not ready to play.");
    }
  } else {
    try {
      video.pause();
      button.classList.remove("hidden");
      e.classList.remove("is-playing");
    } catch (error) {
      console.error("Error pausing video:", error);
    }
  }
}

